import { NomenclatureModel } from "../models/nomenclature-model";

export enum RoleNomenclature {
    ADMIN = 1,
    MANAGER = 2,
    EMPLOYEE = 3,
}

export enum RoleNomenclatureString {
  ADMIN = 'Admin',
  MANAGER = 'Manager',
  EMPLOYEE = 'Employee'
}

export const RoleNomenclatureMap: Map<RoleNomenclature, NomenclatureModel> = new Map([
    [RoleNomenclature.ADMIN, { id: RoleNomenclature.ADMIN, name: 'Админ' }],
    [RoleNomenclature.MANAGER, { id: RoleNomenclature.MANAGER, name: 'Мениджър' }],
    [RoleNomenclature.EMPLOYEE, { id: RoleNomenclature.EMPLOYEE, name: 'Служител' }],
]);
